import { createFileRoute } from "@tanstack/react-router"
import { procedureStepSettingsFieldsViewStaticData } from "src/views/ProcedureStepSettingsFieldsView/constants"
import { ProcedureStepSettingsFieldsView } from "src/views/ProcedureStepSettingsFieldsView/ProcedureStepSettingsFieldsView"

export const Route = createFileRoute(
	"/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/steps/$procedureStepId/fields",
)({
	component: ProcedureStepSettingsFieldsView,
	staticData: procedureStepSettingsFieldsViewStaticData,
})
